export default "__VITE_ASSET__C95LMw5n__"